<template>
  <TheHelpMenu />
  <NotificationsToggleIcon />
  <TheProfileMenu class="ml-2" />
</template>

<script setup>
import NotificationsToggleIcon from '@/app/shared_components/navbar/notifications/TheNotificationsToggleIcon.vue';
import TheProfileMenu from '@/app/shared_components/navbar/TheProfileMenu.vue';
import TheHelpMenu from '@/app/shared_components/navbar/TheHelpMenu.vue';
</script>
